import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const CLAIMS_HISTORY_FETCH_PENDING = 'CLAIMS_HISTORY_FETCH_PENDING';

export const fetchClaimsHistoryPageData = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: CLAIMS_HISTORY_FETCH_PENDING,
        claimsWebsocket: true,
        command: claimsWebsocketCommands.CLAIMS_HISTORY_GET,
        payload: {
            pageSize: pageSize,
            sorted: sorted,
            cursor,
            isNextFromPivot,
            filtered: filtered
        }
    });
};
